// extracted by mini-css-extract-plugin
export var hidden = "_3x-1";
export var leftPanel = "_3x-2";
export var readonlyInspector = "_3x-3";
export var rightPanel = "_3x-0";